/*
 * What sits around every signed-in screen, for the pharmacy and the homes alike: the name and who is
 * signed in along the top, and the notices that have to be seen before anything else.
 */
import type { ReactNode } from 'react';
import type { User } from './api.ts';
import { ConnectionBanner } from './connection.tsx';

export function Brand() {
  return (
    <div className="brand">
      <span className="brand-name">AYP Connect</span>
      <span className="brand-sub">eMAR</span>
    </div>
  );
}

export function TopBar({ user, onSignOut, before }: { user: User; onSignOut: () => void; before?: ReactNode }) {
  return (
    <header className="topbar">
      {before}
      <Brand />
      <div className="who">
        <span className="who-name">{user.name}</span>
        <span className="muted small">{user.jobTitle}</span>
      </div>
      <button type="button" className="quiet" onClick={onSignOut}>Sign out</button>
    </header>
  );
}

/* The no-connection banner, and anything about this login that limits what it can do today. */
export function Notices({ user }: { user: User }) {
  return (
    <>
      <ConnectionBanner />
      {user.agency && user.shiftEndsAt ? (
        <p className="notice">This agency login ends at {user.shiftEndsAt.slice(0, 5)} today.</p>
      ) : null}
      {user.competencyExpired ? (
        <p className="notice warn">
          Your medicines competency has run out. You cannot record medicines until a manager renews it.
        </p>
      ) : null}
    </>
  );
}
